module.exports = __webpack_public_path__ + "img/5B15FE67D50DA4AB.2fc851b0.jpg";